// Thunks for Question Slice
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/constants/api";
import { ApiResponse } from "../../../types/APIResponse";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { Question } from "../../../types";

// Fetch Questions
export const fetchQuestions = createAsyncThunk<
    { data: Question[]; total: number },
    { search_query: string; offset: number; limit: number; subCategoryId?: string },
    { rejectValue: string }
>(
    'questions/fetchQuestions',
    async ({ search_query = '', offset = 0, limit = 10, subCategoryId }, { rejectWithValue }) => {
        try {
            const response: ApiResponse<Question[]> & { counts: number } = await api.post(
                apiEndpoints.question.getAll,
                {
                    data: {
                        search_query,
                        offset,
                        limit,
                        subCategoryId,
                        order: {
                            // id: "ASC"
                            "question.createdAt": "ASC",
                            "options.createdAt": "ASC"
                        }
                    },
                }
            );
            return { data: response.data, total: response.counts };
        } catch (error: any) {
            return rejectWithValue(error?.message || 'Failed to fetch questions');
        }
    }
);

// Create Question
export const createQuestion = createAsyncThunk<Question, Question, { rejectValue: string }>("question/createQuestion", async (requestData, { rejectWithValue }) => {
    try {
        const response = await api.post<ApiResponse<Question>>(apiEndpoints.question.create, { data: requestData });
        return { ...response.data, ...requestData };
    } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || "Failed to create question");
    }
});

// Update Question
export const updateQuestion = createAsyncThunk<Question, Question, { rejectValue: string }>("question/updateQuestion", async (requestData, { rejectWithValue }) => {
    try {
        const response = await api.put<ApiResponse<Question>>(`${apiEndpoints.question.update}/${requestData.id}`, { data: requestData });
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || "Failed to update question");
    }
});

// Delete Question
export const deleteQuestion = createAsyncThunk<{ id: string | number }, string | number, { rejectValue: string }>("question/deleteQuestion", async (id, { rejectWithValue }) => {
    try {
        await api.delete(`${apiEndpoints.question.delete}/${id}`);
        return { id };
    } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || "Failed to delete question");
    }
});
